import FileViewAndUpload from "./FileViewAndUpload";

export default FileViewAndUpload